export default __webpack_public_path__ + "static/media/statistics.4a0fa81e.png";